<template>
  <div class="evaluation-statistical">
      <div @click="showPopup" class="filter" v-if="$route.query.cityChangeFlag">
          <span>请选择业态: {{typeName}}</span>
          <img src="@/assets/image/ic_jiantou_down@2x.png" alt="">
      </div>
    <!-- <van-popup v-model="show" position="bottom" :style="{ height: '30%' }" >
        <van-picker
            title="业态"
            :show-toolbar="true"
            :columns="columns"
            @confirm="onConfirm"
            @cancel="onCancel"
        />
    </van-popup> -->
    <common-picker
      ref="commercial"
      :typeList="columns"
      :cols="1"
      @getTypeValue="TeamAppointment"
    ></common-picker>
    <div class="table">
        <div class="cloumn d-flex justify-content-space-around align-items-center">
            <div>-</div>
            <div>应评数</div>
            <div>已评数</div>
            <div>完成率</div>
        </div>
        <div class="value d-flex justify-content-space-around align-items-center"  v-for="(item, index) in list" :key="index">
            <div>{{item.title}}</div>
            <div>{{item.planNum}}</div>
            <div>{{item.ratedNum}}</div>
            <div v-if="Number(item.ratedNum) > Number(item.planNum)">100%</div>
            <div v-else>{{isNaN(((item.ratedNum / item.planNum) * 100).toFixed(0)) ? 0 : (Math.floor((item.ratedNum / item.planNum) * 100))}}%</div>
        </div>
    </div>
  </div>
</template>
<script>
import api from '../../../../service/modules/integrity';
import API from '../../../../service/modules/refund';
import commonPicker from "../../../../components/base/commonPicker";
export default {
  name: "EvaluationStatistical",
  data() {
    return {
        list: [],
        typeListAll: [],
        columns: [],
        show: false,
        typeName: '全部'
    };
  },
  components: {
      commonPicker
  },
    created() {
        this.evaluationCount();
        this.getindustryCategory();
        console.log(this.$route.query)
        
    },
  mounted() {},
  computed: {
  },
  watch: {},
  methods: {
        getindustryCategory () {
                api.industryCategory().then(res => {
                if (res.ret === 0) {
                    this.typeListAll = res.data;
                    this.typeListAll.unshift({code: '', name: '全部'})
                    this.columns = [this.typeListAll.map(item => {
                        return {value: item.code, text: item.name}
                    })]
                    console.log('res.data',this.columns)
                    console.log('this.typeListAll',this.typeListAll)
                }
            });
        },
        TeamAppointment(value) {
            console.log('value',value);
            this.typeName = value[0].text
            this.evaluationCount(value[0].value)


        },
        evaluationCount(code) {
            api.evaluationCount({
                evaluationId: this.$route.query.evaluationId,
                industryCategory: code
            }).then(res => {
                this.list = res.data;
            })
        },
        onConfirm(value, index) {
            this.typeName = value
            this.evaluationCount(this.typeListAll[index].code)
            this.show = false
        },
        onCancel() {
            this.show = false;
        },
        showPopup() {
            this.show = true;
            this.$refs.commercial.showPicker();
        },
  },
};
</script>

<style lang="less" scoped>
.d-flex {
    display: flex;
}
.flex-dircetion-column {
  flex-direction: column;
}
.justify-content-space-around {
    justify-content: space-around
}
.align-items-center {
    align-items: center;
}
.filter {
    display: flex;
    font-size: 14px;
    padding: 14px 12px;
    img {
        width: 8px;
        height: 6px;
        margin-left: 5px;
        margin-top: 2px;
    }
}
.evaluation-statistical {
    background-color: #F5F6F9;
    height: 100%;
    padding: 12px;
    .table {
        box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.04);
        background-color: #fff;
        border-radius: 3px;
        .cloumn { 
            height: 41px;
            background: #F9F9F9;
            border-radius: 3px 3px 0px 0px;
            color: #666666;
            font-size: 12px;
            div {
                width: 25%;
                text-align: center;
            }
        }
        .value {
            height: 41px;
            color: #333333;
            font-size: 12px;
            div {
                width: 25%;
                text-align: center;
            }
            &:first-of-type {
                border-bottom: 1px solid #eee;
            }
        }
    }
}
</style>
